import { Operation } from '../types/operationTypes';

class SignatureService {
  async createSignature(operation: Operation, selectedPrestataire: number): Promise<void> {
    const selectedCommande = operation.commandes[selectedPrestataire];

    if (!selectedCommande) {
      throw new Error("Impossible de trouver la commande pour la signature.");
    }

    const blob = await fetch("https://core.a3n.fr/template-subsequent").then((res) => res.blob());
    const documentFile = new File([blob], "Template_subsequent_V2.pdf", { type: "application/pdf" });

    const formData = new FormData();

    const responsableAchatId = operation.organisme?.responsable_achat?.id;
    const gestionnaireEntiteId = selectedCommande.contrat?.entite?.gestionnaire_entite?.id;

    if (!responsableAchatId || !gestionnaireEntiteId) {
      throw new Error("Impossible de lancer la signature : certains identifiants manquent.");
    }

    formData.append("user_ids[0]", responsableAchatId.toString());
    formData.append("user_ids[1]", gestionnaireEntiteId.toString());
    formData.append("name", `Contrat ${operation.nom}`);
    formData.append("expiration_date", selectedCommande.expire_at);
    formData.append("document", documentFile);
    formData.append("external_type", "operation");
    formData.append("external_id", operation.id.toString());

    const response = await fetch(`${process.env.REACT_APP_API_URL}/documents/sign`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error("Erreur lors de la création de la signature");
    }

    const data = await response.json();

    if (data?.signature_link) {
      window.open(data.signature_link, "_blank");
    }
  }
}

export const signatureService = new SignatureService();